<template>
  <div>
    <div class="login-panel">
      <div class="main">
        <div class="left">
          <h2 class="title">{{$t('title')}}</h2>
          <form class="form" @submit.prevent="save">
            <div
              class="form-group"
              :class="{active: form.email || formFocus.email, error: $v.form.email.$error}"
            >
              <p class="label">{{$t('email')}}</p>
              <input
                class="input"
                autocomplete="off"
                autofocus="autofocus"
                @focus="focus('email')"
                @blur="blur('email')"
                v-model.trim="form.email"
                type="text"
              >
              <vd-tips path="form.email"/>
            </div>
            <button class="submit" type="submit">{{$ct('confirm1')}}</button>
          </form>
          <p class="tips">
            <router-link :to="iPath('/login')">{{$t('login')}}</router-link>
          </p>
        </div>
        <div class="right"></div>
      </div>
      <ul class="footer">
        <li>
          <router-link :to="iPath('/termsService')">{{$ct('termsService')}}</router-link>
        </li>
        <li>
          <router-link :to="iPath('/privacyPolicy')">{{$ct('privacyPolicy')}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { post } from '@/utils/ajax'
import { required, email, validationMixin } from '@/utils/mixin_validate'
export default {
  inject: ['iPath'],
  mixins: [validationMixin({ tipsType: '' })],
  data() {
    return {
      formFocus: {
        email: false
      },
      form: {
        email: ''
      }
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  computed: {
    validators() {
      return {
        form: {
          email: {
            required: this.$ct('messages.inputEmail'),
            email: this.$ct('messages.emailInvaild')
          }
        }
      }
    }
  },
  methods: {
    focus(item) {
      this.formFocus[item] = true
    },
    blur(item) {
      this.formFocus[item] = false
    },
    async save() {
      await this.validationTouch()
      await post('/edu/zone/password/email', this.form)
      this.$message.success(this.$t('tips'))
    }
  }
}
</script>
<i18n lang="yaml">
en:
  title: Forgot Password
  login: Log In
  email: Email
  tips: A reset password email has been sent. Please check your mailbox
zh-CN:
  title: 忘记密码
  login: 登 录
  email: 邮箱
  tips: 重置密码邮件已发送，请查看邮箱
zh-TW:
  title: 忘記密碼
  login: 登 錄
  email: 郵箱
  tips: 重置密碼郵件已發送，請查看郵箱
it:
  title: Password dimenticata
  login: Accesso
  email: E-mail
  tips: E’ stata inviata un’e-mail di reimpostazione della password. Controlla tua e-mail
id:
  title: Lupa kata sandi
  login: Masuk
  email: E-mail
  tips: E-mail atur ulang kata sandi telah berhasil dikirim. Silahkan periksa E-mail Anda
</i18n>
